export default "__VITE_ASSET__M$CrFOVk__"